// extracted by css-extract-rspack-plugin
export default {"baseContainer":"base-container--wGsZYiV3eIwHt6Fv","container":"container--t_6dCUN6wBLm3wye","modalContainer":"modal-container--aBXq6_BkwS0ftiY6"};